var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"two-line":""}},[_c('v-list-item-content',[_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.reply.field.title))]),_c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('img',{staticClass:"mr-4 elevation-3",attrs:{"width":"400px","src":_vm.reply.field_drawing.url}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }